import { ReactNode } from "react";

// 고객 화면 제목 규칙은 route head(customerHead)가 맡는다.
const CustomerLayout = ({ children }: { children: ReactNode }) => children;

export default CustomerLayout;
